module.exports = __webpack_public_path__ + "908e4d2e/img/question-icon.06c20c5d.svg";